<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" label-position="top">
				<!-- 索赔申请 -->
				<div class="create-section">
					<h3>索赔申请</h3>
					<div class="type-list">
						<el-tooltip
							class="item"
							effect="dark"
							content="仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）"
							placement="bottom"
							popper-class="create-tooltip">
							<div class="claim-type selected">
								商品（耗材）故障
								<div class="tip">
									仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）
								</div>
							</div>
						</el-tooltip>
					</div>
				</div>
				<!-- 申请方信息 -->
				<div class="create-section pb0">
					<h3>索赔类型：{{ matertialTypeOptions[form.matertialType] }}</h3>
				</div>
				<div class="create-section pb0">
					<h3>申请方信息：{{ form.applyOrgName }}</h3>
				</div>
				<!-- 索赔状态 -->
				<div class="create-section pb0">
					<h3>
						索赔状态
						<el-tag type="info">{{ auditStatusMsg }}</el-tag>
						<span class="number-span" v-if="form.serialNumber">编号：{{ form.serialNumber }}</span>
					</h3>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 基本信息 -->
				<div class="create-section">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader
									v-model="form.repairDevices"
									:options="repairDeviceOptions"
									:props="{ value: 'id', label: 'name' }"
									:disabled="form.id ? true : false"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								{{ form.repairDeviceNumber }}
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="开始使用日" prop="partsClaimMaterial.startUseDate">
								{{ form.partsClaimMaterial.startUseDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="问题发生日" prop="partsClaimMaterial.issueDate">
								{{ form.partsClaimMaterial.issueDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="使用张数" prop="partsClaimMaterial.pagesUsed">
								{{ form.partsClaimMaterial.pagesUsed }}
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="故障现象" prop="partsClaimMaterial.failureSymptom">
							{{ form.partsClaimMaterial.failureSymptom }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理措施" prop="partsClaimMaterial.failureAction">
							{{ form.partsClaimMaterial.failureAction }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimMaterial.additionalNotes">
							{{ form.partsClaimMaterial.additionalNotes }}
						</el-form-item>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section">
					<h3>上传附件</h3>
					<!-- 理光出库一览表 -->
					<div class="upload-box">
						<h4>理光出库一览表</h4>
						<FileList :file-list="ricohOutboundFileIdList" list-name="ricohOutboundFileIdList" class="mt4"></FileList>
					</div>
					<!-- 理光购货发票 -->
					<div class="upload-box">
						<h4>理光购货发票</h4>
						<FileList :file-list="ricohPurchaseFileIdList" list-name="ricohPurchaseFileIdList" class="mt4"></FileList>
					</div>
					<!-- 故障件照片和样张 -->
					<div class="upload-box">
						<h4>故障件照片和样张</h4>
						<FileList :file-list="faultyPartsFileIdList" list-name="faultyPartsFileIdList" class="mt4"></FileList>
					</div>
				</div>
				<!-- 客户信息 -->
				<div class="create-section">
					<h3>客户信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="用户名" prop="partsClaimCustomer.userName">
								{{ form.partsClaimCustomer.userName }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="联系人姓名" prop="partsClaimCustomer.contactName">
								{{ form.partsClaimCustomer.contactName }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="用户电话" prop="partsClaimCustomer.userPhone">
								{{ form.partsClaimCustomer.userPhone }}
							</el-form-item>
						</div>
					</div>
					<div class="grid-box grid-box1">
						<div>
							<el-form-item label="省市区" prop="partsClaimCustomer.allAddress">
								<el-cascader
									v-model="form.partsClaimCustomer.allAddress"
									:options="addressOptions"
									:props="{ value: 'code', label: 'name' }"
									:disabled="form.id ? true : false"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="详细地址" prop="partsClaimCustomer.addressDetail">
								{{ form.partsClaimCustomer.addressDetail }}
							</el-form-item>
						</div>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}名称</p>
									<p class="content">{{ part.partsName }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}编号</p>
									<p class="content">{{ part.partsNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsNumberNew != null">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}新编号</p>
									<p class="content">{{ part.partsNumberNew }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">申请数量</p>
									<p class="content">{{ part.partsAmount }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsBatchNumber != null">
								<div class="info-box">
									<p class="title">批号</p>
									<p class="content">{{ part.partsBatchNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
							</div>
							<img class="watermark" v-if="part.lastResult == 1" src="@/assets/images/claim-fail.png" alt="" />
							<img
								class="watermark"
								v-if="part.currentAudit && part.currentAudit.auditStatus == 3"
								src="@/assets/images/claim-success.png"
								alt="" />
						</div>
						<div class="flex-1 part-info-box-right">
							<div v-if="[42, 44].includes(auditStatus)">零件索赔进度： 实物审批中</div>
							<div v-if="[4, 7, -7].includes(auditStatus)">
								<div class="right-item">实物检测结果： {{ part.partsResult == 1 ? "拒绝" : "同意" }}</div>
								<div class="right-item" v-if="part.partsTest">测试结果： {{ part.partsTest == 1 ? "正常" : "故障" }}</div>
								<div class="right-item">零件索赔进度：{{ progressMsg(part) }}</div>
								<el-button v-if="part.partsResult == 1 && part.partsClaimExpress" type="info" @click="checkAddressInfo(part.partsClaimExpress)">
									查看索赔退件信息
								</el-button>
								<div class="right-item" v-if="part.currentAudit && part.currentAudit.auditStatus == 2">
									预计发货时间： {{ part.estimatedShippingTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货订单号：{{ part.partsClaimExpress.expressNumber }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货操作时间(系统)：{{ part.currentAudit.operTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货时间(录入)：{{ part.actualShippingTime }}
								</div>
								<div class="right-item word-bread-all" v-if="part.currentAudit && [2, 3, -2].includes(part.currentAudit.auditStatus)">
									发货批注： {{ part.currentAudit.remark }}
								</div>
								<div class="right-item flex" v-if="part.fileList.length > 0">
									<span>附件说明</span>
									<div class="flex-1">
										<FileList :file-list="part.fileList" class="mt4"></FileList>
									</div>
								</div>
								<el-button v-if="part.partsResult == 2 && part.partsClaimExpress" type="info" @click="checkAddressInfo(part.partsClaimExpress)">
									查看索赔邮寄信息
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<div class="create-footer">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button type="primary" @click="handleDownloadPdf" v-if="[7].includes(auditStatus)">打印索赔报告书</el-button>
		</div>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<appendix3 ref="appendix3" />
	</div>
</template>

<script>
import { claimMaterialInfo } from "@/api/claim";
import FileList from "../components/FileList.vue";
import AddressInfo from "../components/addExpress.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import appendix3 from "@/components/PdfTemplate/AppendixReport/appendix3.vue";
export default {
	components: {
		FileList,
		AddressInfo,
		ShowAddressInfo,
		appendix3,
	},
	data() {
		return {
			matertialTypeOptions: {
				1: "主机",
				2: "耗材",
				3: "选购件",
			},
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 机型及开发名
			repairDeviceOptions: [],
			// 省市县三级
			addressOptions: [],
			form: {
				submitTime: "",
				serialNumber: "",
				matertialType: "", //商品（耗材故障） 具体类型 1主机  2耗材 3选购件
				repairType: "3", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimMaterial: {
					startUseDate: "", // 开始使用日
					issueDate: "", // 问题发生日
					pagesUsed: "", // 使用张数
					failureSymptom: "", // 故障现象
					failureAction: "", // 故障措施
					additionalNotes: "", // 补充说明栏
					ricohOutboundFileIdList: [], //理光出库一览表 单上传文件的id
					ricohPurchaseFileIdList: [], //理光购货发票 上传文件的id
					faultyPartsFileIdList: [], //故障件照片和样张 上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			// 装箱单附件列表
			ricohOutboundFileIdList: [],
			// 故障样张或照片附件列表
			ricohPurchaseFileIdList: [],
			// 订购的故障零件，外包装等照片附件列表
			faultyPartsFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 资料审核管理员是否显示
			auditOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			// 索赔状态
			auditStatus: "",
			auditStatusMsg: "",
			logList: [],
		};
	},
	mounted() {
		// 获取机型及开发名
		this.getRepairDevice();
		this.getDataAddr();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimOrdersInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimOrdersInfo(claimId) {
			let self = this;
			claimMaterialInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
						sessionStorage.setItem("claimId", r.data.id);
						sessionStorage.setItem("repairType", r.data.repairType);

						self.auditStatus = r.data?.currentAudit?.auditStatus;
						self.form.id = r.data.id;
						self.form.matertialType = r.data.matertialType;
						self.form.repairType = r.data.repairType;
						self.form.applyOrgName = r.data.applyOrgName;
						self.form.applyOrgType = String(r.data.applyOrgType);
						self.form.applyOrgId = r.data.applyOrgId;
						self.form.repairDeviceId = r.data.repairDeviceId;
						self.form.repairDeviceNumber = r.data.repairDeviceNumber;
						self.form = Object.assign({}, self.form, r.data);
						self.form.partsClaimMaterial = {
							id: r.data.partsClaimMaterial.id,
							startUseDate: r.data.partsClaimMaterial.startUseDate, // 开始使用日
							issueDate: r.data.partsClaimMaterial.issueDate, // 问题发生日
							pagesUsed: r.data.partsClaimMaterial.pagesUsed, // 使用张数
							failureSymptom: r.data.partsClaimMaterial.failureSymptom, // 故障现象
							failureAction: r.data.partsClaimMaterial.failureAction, // 故障措施
							additionalNotes: r.data.partsClaimMaterial.additionalNotes, // 补充说明栏
							ricohOutboundFileIdList: [], //理光出库一览表
							ricohPurchaseFileIdList: [], //理光购货发票
							faultyPartsFileIdList: [], //故障件照片和样张
						};
						self.form.partsDetailList = [...r.data.partsDetailList];

						// 机型及开发名
						r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
						self.ricohOutboundFileIdList = r.data.partsClaimMaterial.ricohOutboundFileList;
						self.ricohPurchaseFileIdList = r.data.partsClaimMaterial.ricohPurchaseFileList;
						self.faultyPartsFileIdList = r.data.partsClaimMaterial.faultyPartsFileList;

						self.form.partsClaimCustomer = { ...r.data.partsClaimCustomer };
						// 省市区
						self.form.partsClaimCustomer.allAddress = [
							r.data.partsClaimCustomer.province,
							r.data.partsClaimCustomer.city,
							r.data.partsClaimCustomer.district,
						];

						self.auditStatusMsg = r.data.currentAudit.operNotes;
						self.form.serialNumber = r.data.serialNumber;
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
					// 错误处理已在拦截器中统一处理
				});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取省市县三级
		getDataAddr() {
			let self = this;
			self.$request.get("getDataAddr", false, {}, function (r) {
				if (r.code == "0") {
					self.addressOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 查看索赔退件信息
		checkAddressInfo(partsClaimExpress) {
			this.$refs.showAddressInfo.init(partsClaimExpress);
		},
		// 索赔进度
		progressMsg(part) {
			let msg = "";
			if (part.partsResult == 1) {
				msg = "实物审批被拒";
			} else if (part.currentAudit) {
				if (part.currentAudit.auditStatus == 1) {
					msg = "实物审批已通过";
				} else if (part.currentAudit.auditStatus == 2) {
					msg = "无货等待";
				} else if (part.currentAudit.auditStatus == 3) {
					msg = "索赔成功";
				} else if (part.currentAudit.auditStatus == -2) {
					msg = "拒绝发货";
				} else {
					msg = "实物审批已通过";
				}
			} else {
				return "";
			}
			return msg;
		},
		// 下载pdf
		handleDownloadPdf() {
			// 默认模板
			const newForm = {
				...this.$data,
			};
			if (!newForm) {
				console.error("默认模板 data is undefined");
				return;
			}
			this.$refs.appendix3.init(newForm);
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
	.flex-1 {
		position: relative;
		min-width: 0;
		word-wrap: break-word;
		.watermark {
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
		.flex-1 {
			padding-top: 0;
		}
	}
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}

.subtitle {
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.75;
	letter-spacing: 0.00938em;
	margin: 0 20px;
}
.border-bottom-none {
	border-bottom: none !important;
}
.pb0 {
	padding-bottom: 0;
}
.height45 {
	height: 45px !important;
}
.add-section {
	margin: 0 20px;
	.title1,
	.el-input,
	.el-button {
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		font-size: 12px;
	}
}
.number-span {
	float: right;
	font-size: 16px;
	font-weight: normal;
}
.word-bread-all {
	white-space: pre-line;
	word-break: break-all;
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
